module.exports = __webpack_public_path__ + "static/media/12.06fb2a98.png";